import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Alert, AlertSubType, AlertType } from '../data/alerting.models';

@Pipe({
  name: 'alertDescription',
  standalone: true,
})
export class AlertDescriptionPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(alert: Alert): string {
    if (alert.alertType === AlertType.WEBSOCKET_AUTH) {
      return this.translate.instant('ALERTING.ALERT_STATUS_WEBSOCKET_AUTH_DESCRIPTION');
    } else if (!alert.alertSubType || alert.alertSubType == AlertSubType.UNKNOWN) {
      return this.translate.instant('ALERTING.ALERT_STATUS_' + alert.alertType);
    } else if (alert.alertType === AlertType.CHARGING_SESSION) {
      return this.translate.instant('ALERTING.ALERT_STATUS_' + alert.alertSubType);
    } else {
      return this.translate.instant(
        'ALERTING.ALERT_STATUS_' + alert.alertType + '_' + alert.alertSubType
      );
    }
  }
}
